export default __webpack_public_path__ + "static/media/r-nobg-logo-fullside.57dd4547.png";